<template>
  <div class="tab-menu">
    <ul class="tabs">
      <li v-for="tab in tabs" :key="tab.value" @click="setTab(tab.value)" :class="{ active: (tab.value === value) }">
        <font-awesome-icon v-if="!!tab.icon && isDesktop" class="icon" :icon="tab.icon" />
        <center v-else><font-awesome-icon v-if="!!tab.icon" class="icon" :icon="tab.icon" /></center>
        <div class="text">{{ $t(tab.text) }}</div>
      </li>
    </ul>
    <div class="line" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'TabMenu',
  props: {
    tabs: {
      type: Array,
      default: () => [],
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  setup(props, { emit }) {
    const { isDesktop } = useAppState(['isDesktop']);

    const setTab = (val) => {
      emit('input', val);
    };

    return {
      isDesktop,
      setTab
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.tab-menu {
  position: relative;
  user-select: none;

  @media (max-width: 991px) {
    overflow-y: scroll;
  }

  .line {
    background-color: $alto;
    height: 0.5px;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .tabs {
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: relative;
    z-index: 2;

    li {
      display: inline-block;
      padding: 15px 30px;
      padding-left: 30px;
      background-color: $alto;
      border-right: 0;
      position: relative;
      box-sizing: border-box;

      @media (min-width: 992px) {
        margin-right: 20px;
        border: 1px solid $alto;
        border-top-left-radius: 4px;
      }

      color: $grey;
      cursor: pointer;
      transition: all .2s ease-in-out;
      text-transform: capitalize;

      .icon {
        vertical-align: middle;
        margin-right: 7px;
      }

      .text {
        display: inline-block;
        font-weight: bold;
        vertical-align: middle;
      }

      @media (min-width: 992px) {
        &::after {
          content: "";
          width: 30px;
          height: calc(100% + 2px);
          box-sizing: border-box;
          background-color: $alto;
          border: 1px solid $alto;
          border-left: 0;
          position: absolute;
          top: -1px;
          right: -20px;
          transform: skew(20deg);
          transition: all .2s ease-in-out;
          border-top-right-radius: 4px;
        }
      }

      &:hover, &.active {
        background-color: $babyPowder;
        border-bottom-color: $babyPowder;
        color: $brightMaroon;

        &::after {
          background-color: $babyPowder;
          border-bottom-color: $babyPowder;
        }
      }

       &.active {
         z-index: 9;
       }
    }
  }
}
</style>
